import { CappieReporterTypes } from '@mode/shared/contract-common';
import { createAction, props } from '@ngrx/store';

export const progressReporting = createAction(
  '[Cappie Reporter] Progress Reported',
  props<{
    eventData: CappieReporterTypes.ProgressData;
  }>()
);

export type Union = ReturnType<typeof progressReporting>;
